import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import getChartColorsArray from "Components/Common/ChartsDynamicColor";
import ReactApexChart from "react-apexcharts";
import useQueryState from "Components/Hooks/UseQueryState";
import { getPaymentsGenderDistribution } from "common/services/payments.service";
import { getYearDateRange } from "common/lib/dateUtils";
import { useProfile } from "Components/Hooks/UserHooks";

const convertGenderData = (data: {
  [key: string]: { count: number; totalAmountPerMonth: number };
}) => {
  // Extract property names into a labels array
  const labels = Object.keys(data);

  // Extract counts into a series array
  const countSeries = labels.map((key) => data[key].count);

  // Extract totalAmountPerMonth into another series array
  const totalAmountPerMonthSeries = labels.map(
    (key) => data[key].totalAmountPerMonth
  );

  return { labels, countSeries, totalAmountPerMonthSeries };
};

const ContractDistributionChart = ({
  data,
  labels,
}: {
  data: number[];
  labels: string[];
}) => {
  const chartPieBasicColors = getChartColorsArray(
    // '["#088f7d", "--vz-success", "--vz-warning", "--vz-danger", "--vz-info"]'
    '["#1C92D8", "#F06C6B", "#CCCCCC"]' // #8ECEFD, #F88B9D
  );

  const options = {
    chart: {
      height: 450,
      type: "pie",
    },
    labels: labels,
    legend: {
      position: "top",
    },
    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    colors: chartPieBasicColors,
    tooltip: {
      enabled: true, // Enable tooltips
      y: {
        formatter: function (value: number) {
          return value.toLocaleString() + " Contracts"; // Format the tooltip value
        },
        title: {
          formatter: function (seriesName: string) {
            return `${seriesName}:`; // Customize the title of the tooltip
          },
        },
      },
    },
  };

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={data}
      options={options}
      type="pie"
      height={300}
    />
  );
};

const DistributionByGender = () => {
  const { userProfile } = useProfile();
  const [selectedYear] = useQueryState(
    "year",
    new Date().getFullYear().toString()
  );

  const { firstDay, lastDay } = getYearDateRange(Number(selectedYear));

  const [payments, setPayments] = useState({});
  const [, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getPaymentsGenderDistribution({
          startDate: firstDay ? firstDay : undefined,
          endDate: lastDay ? lastDay : undefined,
          agencyId: userProfile?.agency?.id,
        });

        setPayments(response);
      } catch (error) {
        console.warn("Error fetching total  support", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [firstDay, lastDay, userProfile?.agency?.id]);

  const { labels, countSeries } = convertGenderData(payments);
  return (
    <Card className="card-height-100">
      <CardHeader>
        <h4 className="card-title mb-0">Distribution by Gender</h4>
      </CardHeader>

      <CardBody>
        <ContractDistributionChart data={countSeries} labels={labels} />
      </CardBody>
    </Card>
  );
};

export default DistributionByGender;
